export function maybeCellValue(
	cellContent: string | null | boolean | undefined,
	modifier?: (content: string | null | boolean) => string
): string {
	if (cellContent === null || cellContent === undefined || cellContent === '') {
		return 'N/A';
	}
	if (typeof cellContent === 'boolean') {
		return cellContent ? 'Yes' : 'No';
	}
	if (modifier && typeof modifier === 'function') {
		return modifier(cellContent);
	}
	return cellContent;
}
